import { render } from "./ModalShips.vue?vue&type=template&id=026bcd02"
import script from "./ModalShips.vue?vue&type=script&lang=js"
export * from "./ModalShips.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__